import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import { IconUpload } from "components/icons/Icons";
import { FileUploader } from "react-drag-drop-files";

interface FinalFileCellProps {
  documentStatusId: string;
  handleChange: (documentId: string, files: File[]) => void;
  documentId: string;
}

export function FinalFileCell({
  documentStatusId,
  handleChange,
  documentId,
}: FinalFileCellProps) {
  const textColor = useColorModeValue("black", "black");

  const getFileName = () => {
    return Number(documentStatusId) === 5 ? "done" : "empty";
  };

  return (
    <Flex align="center">
      <Flex
        color={textColor}
        fontSize="14px"
        lineHeight="24px"
        fontWeight="400"
        alignItems={"center"}
        padding="5px 5px 5px 10px"
        borderRadius="100px"
        border="1px solid #E9E9E9"
      >
        <Box
          maxW="100px"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
        >
          {getFileName()}
        </Box>

        <FileUploader
          multiple={true}
          handleChange={(files: File[]) => {
            handleChange(documentId, files);
          }}
          name="files"
          height="full"
          sx={{
            marginLeft: "32px",
          }}
        >
          <Flex
            padding="5px 20px 5px 15px"
            background="rgba(47, 128, 237, 0.14)"
            borderRadius="20px"
            marginLeft="8px"
            boxSize="fit-content"
            cursor="pointer"
            _hover={{
              color: "#2F80ED",
              textDecoration: "underline",
            }}
          >
            <IconBox icon={<IconUpload width="24px" height="24px" />} />
            <Text
              fontSize={{ sm: "12px", lg: "14px" }}
              lineHeight="24px"
              fontWeight="400"
              color="#2F80ED"
              marginLeft="4px"
            >
              Upload
            </Text>
          </Flex>
        </FileUploader>
      </Flex>
    </Flex>
  );
}
